import { isServer } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';

/**
 * A 404 without giving up the streamed shell, which a loader's `notFound()` would cost on every request
 * (TEC-3823, DR-25). docs/notes/portals/not-found-status.md
 */
export function useNotFoundStatus(missing: boolean): void {
	const router = useRouter();
	if (!isServer || !missing) return;
	markServerResultNotFound(router);
}

interface MutableServerRenderResult {
	type: 'render';
	status: number;
}

/**
 * FAILS OPEN: `_serverResult` is private and has moved between minor versions; the unit test pins its shape.
 */
export function markServerResultNotFound(router: unknown): void {
	if (typeof router !== 'object' || router === null) return;
	const candidate = (router as { _serverResult?: unknown })._serverResult;
	if (typeof candidate !== 'object' || candidate === null) return;
	const result = candidate as { type?: unknown; status?: unknown };
	if (result.type !== 'render' || typeof result.status !== 'number') return;
	(result as MutableServerRenderResult).status = 404;
}
